export const formatNumber = (num) => {
  // Verifica si el número es un número válido
  if (typeof num !== 'number' || isNaN(num)) {
    throw new Error('Por favor, ingrese un número válido.');
  }
  
  // Convierte el número a una cadena con comas como separadores de miles
  return num.toLocaleString('en-US');
};